// tslint:disable:max-line-length

/************************************************************************************/
/* WARNING: This file is generated automatically. Don't edit it by hand             */
/************************************************************************************/

import type * as rest from "../rest";
import type * as t from "./users.generated.types";

function enc(s: any) { return encodeURIComponent("" + s); }

export interface IUsers {
    /** Refreshes JWT token for current user */
    refreshToken(req: t.IRefreshTokenReq): Promise<t.IRefreshTokenRes>;

    /** Changes password for current user */
    changePwd(req: t.IChangePwdReq): Promise<t.IChangePwdRes>;

    /** Marks message as read by current user */
    markMessageAsReadByCurrentUser(req: t.IMarkMessageAsReadByCurrentUserReq): Promise<t.IMarkMessageAsReadByCurrentUserRes>;

    /** Gets messages for current user */
    getMessagesForCurrentUser(req: t.IGetMessagesForCurrentUserReq): Promise<t.IGetMessagesForCurrentUserRes>;

    /** Gets data for current user */
    getCurrentUserData(req: t.IGetCurrentUserDataReq): Promise<t.IGetCurrentUserDataRes>;

    /** Log in user with given credentials */
    loginUP(req: t.ILoginUPReq): Promise<t.ILoginUPRes>;

    /** Trigger forgotten password sequence */
    forgotPasswordStart1(req: t.IForgotPasswordStart1Req): Promise<t.IForgotPasswordStart1Res>;

    /** Verify incoming token */
    forgotPasswordStart2(req: t.IForgotPasswordStart2Req): Promise<t.IForgotPasswordStart2Res>;

    /** Set new password with token */
    forgotPasswordStart3(req: t.IForgotPasswordStart3Req): Promise<t.IForgotPasswordStart3Res>;

    /** Validates given JWT token */
    validateToken(req: t.IValidateTokenReq): Promise<t.IValidateTokenRes>;

}

export class Users implements IUsers {

    private client: rest.IApiClient;

    constructor(client: rest.IApiClient) { this.client = client; }

    /** Refreshes JWT token for current user */
    public async refreshToken(req: t.IRefreshTokenReq): Promise<t.IRefreshTokenRes> {
        const reqx: any = req;
        const url = `/api/v1.0/users/me/refresh-jwt-token`;
        return (await this.client.post(url, reqx));
    }

    /** Changes password for current user */
    public async changePwd(req: t.IChangePwdReq): Promise<t.IChangePwdRes> {
        const reqx: any = req;
        const url = `/api/v1.0/users/change-pwd`;
        return (await this.client.post(url, reqx));
    }

    /** Marks message as read by current user */
    public async markMessageAsReadByCurrentUser(req: t.IMarkMessageAsReadByCurrentUserReq): Promise<t.IMarkMessageAsReadByCurrentUserRes> {
        const reqx: any = req;
        const url = `/api/v1.0/users/mark-msgs-as-read`;
        return (await this.client.post(url, reqx));
    }

    /** Gets messages for current user */
    public async getMessagesForCurrentUser(req: t.IGetMessagesForCurrentUserReq): Promise<t.IGetMessagesForCurrentUserRes> {
        const reqx: any = req;
        const url = `/api/v1.0/users/me/messages`;
        return (await this.client.get(url, reqx));
    }

    /** Gets data for current user */
    public async getCurrentUserData(req: t.IGetCurrentUserDataReq): Promise<t.IGetCurrentUserDataRes> {
        const reqx: any = req;
        const url = `/api/v1.0/users/me`;
        return (await this.client.get(url, reqx));
    }

    /** Log in user with given credentials */
    public async loginUP(req: t.ILoginUPReq): Promise<t.ILoginUPRes> {
        const reqx: any = req;
        const url = `/api/v1.0/users/login`;
        return (await this.client.post(url, reqx));
    }

    /** Trigger forgotten password sequence */
    public async forgotPasswordStart1(req: t.IForgotPasswordStart1Req): Promise<t.IForgotPasswordStart1Res> {
        const reqx: any = req;
        const url = `/api/v1.0/users/forgot-password-1`;
        return (await this.client.post(url, reqx));
    }

    /** Verify incoming token */
    public async forgotPasswordStart2(req: t.IForgotPasswordStart2Req): Promise<t.IForgotPasswordStart2Res> {
        const reqx: any = req;
        const url = `/api/v1.0/users/forgot-password-2`;
        return (await this.client.post(url, reqx));
    }

    /** Set new password with token */
    public async forgotPasswordStart3(req: t.IForgotPasswordStart3Req): Promise<t.IForgotPasswordStart3Res> {
        const reqx: any = req;
        const url = `/api/v1.0/users/forgot-password-3`;
        return (await this.client.post(url, reqx));
    }

    /** Validates given JWT token */
    public async validateToken(req: t.IValidateTokenReq): Promise<t.IValidateTokenRes> {
        const reqx: any = req;
        const url = `/api/v1.0/users/validate-token`;
        return (await this.client.post(url, reqx));
    }

}
